<template>
  <v-app style="background:#0e0e10">
    <nav-vue />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import NavVue from './components/Nav.vue'
import supabase from '@/api/supabase/index'

export default {
  name: 'App',
  components: { NavVue },

  async created () {
    // Restore session from Supabase's own localStorage token
    const session = await supabase.getSession()
    if (session?.user) {
      this.$store.commit('setUser', session.user)
      await this.syncUserData(session.user)
    }
    this.$store.commit('setAuthLoading', false)

    // Subscribe to auth changes for the lifetime of the app
    const { data: { subscription } } = supabase.onAuthStateChange(
      async (event, newSession) => {
        const user = newSession?.user ?? null
        this.$store.commit('setUser', user)
        // INITIAL_SESSION / TOKEN_REFRESHED are already covered by the
        // getSession() bootstrap above — only a real sign-in needs a sync.
        if (user && event === 'SIGNED_IN') {
          await this.syncUserData(user)
        }
      }
    )
    this._authSubscription = subscription

    // Mirror local wishlist changes to Supabase while signed in
    this._unsubscribeStore = this.$store.subscribe((mutation, state) => {
      const user = state.currentUser
      if (!user) return
      if (mutation.type === 'addToWishlist') {
        supabase.addWishlistItem(user.id, mutation.payload)
          .catch(err => console.error('Wishlist sync error:', err))
      } else if (mutation.type === 'removeFromWishlist') {
        supabase.removeWishlistItem(user.id, mutation.payload)
          .catch(err => console.error('Wishlist sync error:', err))
      }
    })
  },

  beforeDestroy () {
    if (this._authSubscription) {
      this._authSubscription.unsubscribe()
    }
    if (this._unsubscribeStore) {
      this._unsubscribeStore()
    }
  },

  methods: {
    // Pull the user's alerts + wishlist from Supabase, after first pushing up
    // any wishlist items saved locally while signed out.
    async syncUserData (user) {
      try {
        const alerts = await supabase.getPriceAlerts(user.id)
        if (alerts.length) this.$store.commit('loadWishlistAlerts', alerts)

        const local = this.$store.state.wishlist || []
        if (local.length) await supabase.bulkUpsertWishlist(user.id, local)
        const merged = await supabase.fetchWishlist(user.id)
        if (merged.length) this.$store.commit('listWishlist', merged)
      } catch (err) {
        console.error('User data sync error:', err)
      }
    },
  },
}
</script>
